import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import { magicLampsAnim } from '../magiclamps/MagicLampsAnim';
import { createWaiter } from 'src/lib/utils';
import { randomFloat } from '../odie';

export type EmitterConfig = {
  particleCount: number;
  scaleInterval: [number, number];
  duration: number;
};

export class ShineStarsFx extends View {
  private stars: ImageScaleView[] = [];
  private idleStars: ImageScaleView[] = [];
  private waiter?: ReturnType<typeof createWaiter>;
  private emitterConfig = {
    particleCount: 4,
    scaleInterval: [0.5, 0.75],
    duration: 400,
  };

  constructor(opts: ViewOpts & { emitterConfig?: Partial<EmitterConfig> }) {
    super({ ...opts });

    const asset = 'assets/ui/match2/common/shine_particle.png';
    this.emitterConfig = {
      ...this.emitterConfig,
      ...opts.emitterConfig,
    };

    for (let i = 0; i < this.emitterConfig.particleCount; i++) {
      this.addStar(asset);
    }
  }

  private addStar(image: string) {
    this.stars.push(
      new ImageScaleView({
        image,
        superview: this,
        visible: false,
        centerOnOrigin: true,
        width: 27,
        height: 27,
        scaleMethod: 'contain',
      }),
    );
  }

  public play() {
    this.updateOpts({ visible: true });
    this.idleStars = this.stars.slice();
    this.autoUpdate();
  }

  public stop() {
    this.updateOpts({ visible: false });
    this.stopAutoUpdate();
  }

  private autoUpdate() {
    this.waiter?.clear();
    this.waiter = createWaiter();
    this.waiter.wait(this.autoUpdate.bind(this), 100);
    this.playStar();
  }

  private stopAutoUpdate() {
    this.waiter?.clear();
    this.waiter = undefined;
  }

  private async playStar() {
    const star = this.idleStars.pop();
    if (!star) return;
    const x = randomFloat(0, this.style.width);
    const y = randomFloat(0, this.style.height);
    const scale = randomFloat(
      this.emitterConfig.scaleInterval[0],
      this.emitterConfig.scaleInterval[1],
    );
    star.updateOpts({
      visible: true,
      scale: 0,
      x,
      y,
    });
    await magicLampsAnim(
      star,
      { scale },
      this.emitterConfig.duration / 2,
      animate.easeOutSine,
    );
    await magicLampsAnim(
      star,
      { scale: 0 },
      this.emitterConfig.duration / 2,
      animate.easeInSine,
    );
    star.updateOpts({
      visible: false,
      scale: 0,
    });
    this.idleStars.push(star);
  }
}
